/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider, extend, configure } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import draggable from 'vuedraggable';
import { messages } from "./multilingual";
import './bootstrap';
import registerComponents from './appComponents';
import { store } from "./store";
window.Vue = require('vue').default;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueI18n);
Vue.component('draggable', draggable);
// Install vee-validate rules
// https://vee-validate.logaretm.com/v3/guide/rules.html#installing-all-rules
for (var _i = 0, _a = Object.entries(rules); _i < _a.length; _i++) {
    var _b = _a[_i], rule = _b[0], validation = _b[1];
    extend(rule, __assign({}, validation));
}
// Connect vee-validate with vue-i18n
// https://vee-validate.logaretm.com/v3/guide/localization.html#using-other-i18n-libraries
configure({
    defaultMessage: function (field, values) {
        if (values === void 0) { values = {}; }
        values._field_ = "";
        return i18n.t("validation.".concat(values._rule_), values);
    }
});
// Install vee-validate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.config.devtools = true;
var i18n = new VueI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    messages: messages
});
registerComponents();
new Vue({
    i18n: i18n,
    el: '#app',
    store: store,
});
